<template lang="html">
  <button
    class="font-helvetica font-light"
    @click="Answered"
    :class=" $attrs.animation + ' delay-' + ( $attrs.k +1 ) +' bg-'+colourRandom($attrs.k)">
    <span>{{$attrs.answer.answer}}</span>
  </button>
</template>

<script>
import firebase from "firebase/app"
import { mapState } from "vuex"
  export default {
    data () {
      return {
        colours:["herored","heroyellow","heroblue"]
      }
    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
        ...mapState({
        user: "user"
      }),
    },
    methods: {
      Answered() {
        var vm = this;
        var lev = null
        var next = null
        var hero = this.user.profile.hero;

        vm.$emit('questionAnswered', 'animated fadeOut');
        vm.$emit('Disabled', true);
        setTimeout(function(){
        vm.$emit('AnswerAnimation', 'animated bounceOutLeft')
        },
        1000);

        setTimeout(function(){
          if(vm.$attrs.category && vm.$attrs.last){
            lev = vm.$attrs.category
            next = 0
            vm.$router.replace({ name: 'Question', params: { level: lev, id: next } })

            if(vm.$attrs.result) {

                var scored = null

                let array = vm.$attrs.answerData
                console.log(array)
                if(array.length == 0)
                  return null;
                  var modeMap = {};
                  var maxEl = array[0], maxCount = 1;
                  for(var i = 0; i < array.length; i++)
                  {
                      var el = array[i];
                      if(modeMap[el] == null)
                          modeMap[el] = 1;
                      else
                          modeMap[el]++;
                      if(modeMap[el] > maxCount)
                      {
                          maxEl = el;
                          maxCount = modeMap[el];
                      }
                  }
                  scored = maxEl;
                  console.log(scored)

              vm.$router.replace({ name: 'Result', params: { score: scored } })
            }

          } else {
            lev = vm.$attrs.category
            next = Number(vm.$route.params.id + 1)
            vm.$router.replace({ name: 'Question', params: { level: lev, id: next } })
          }


          vm.$emit('questionAnswered', 'animated fadeIn fast');
          vm.$emit('AnswerAnimation', 'animated bounceInRight');
          vm.$emit('Disabled', false);
        },
        2000);

        // Save data
        let data = []
        let incoming = vm.$attrs.answerData
        let newanswer = this.$attrs.answer.logic
        data = incoming.concat(newanswer);
        vm.$emit('answerData', data);

        let cats = []
        let catincoming = vm.$attrs.answerCats
        let catnewanswer = this.$attrs.answer.category
        cats = catincoming.concat(catnewanswer);
        vm.$emit('answerCat', cats);

        // Save data Firebase

        if(!hero) {

          var firestore = firebase.firestore();
          var uid = this.user.data.uid;
          var docRef = firestore.doc("users/" + uid);

          docRef.update({
            answerData: vm.$attrs.answerCats,
            answerCats: vm.$attrs.answerData
          })

          }
        },
      colourRandom(key) {
        let randomValue = this.colours[key];
        return randomValue
      }
    }
  }
</script>
